import { useMemo } from 'react';

import { ContractDemandCasesQuery, TsrctSourcingCaseStatus } from '@/generated/gql/graphql';

type ContractDemand = ContractDemandCasesQuery['tesseract']['contractDemand'];

export const useQualifiedSuppliers = (demand?: ContractDemand | null) => {
  const qualifiedSupplierIdsSet = useMemo(
    () => new Set(demand?.demandRequest?.lineItems?.flatMap((item) => item.qualifiedSuppliers).filter(Boolean)),
    [demand?.demandRequest?.lineItems],
  );

  const existingSupplierIdsSet = useMemo(
    () => new Set(demand?.sourcingCases?.map((sc) => sc.supplier?.supplierId).filter(Boolean)),
    [demand?.sourcingCases],
  );

  const qualifiedSuppliers = useMemo(() => {
    return Array.from(qualifiedSupplierIdsSet)
      .filter((id) => !existingSupplierIdsSet.has(id))
      .map((id) => ({
        id,
        name: id,
      }));
  }, [existingSupplierIdsSet, qualifiedSupplierIdsSet]);

  return {
    qualifiedSuppliers,
    existingSupplierIdsSet,
  };
};

export const useReleasableCases = (demand?: ContractDemand | null) => {
  return useMemo(() => {
    return demand?.sourcingCases?.filter((sc) => sc.status === TsrctSourcingCaseStatus.RELEASABLE) || [];
  }, [demand?.sourcingCases]);
};
